module.exports = __webpack_public_path__ + "static/media/mascot@2x.c310ba00.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mascot/mascot@2x.png
// module id = 164
// module chunks = 0